var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWellnessFeatureMedicines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199398",
    "data-name": "Rectangle 199398",
    width: 294.236,
    height: 300,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199379",
    "data-name": "Rectangle 199379",
    width: 22.975,
    height: 11.32,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199383",
    "data-name": "Rectangle 199383",
    width: 22.919,
    height: 12.093,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199384",
    "data-name": "Rectangle 199384",
    width: 23.706,
    height: 13.188,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wellness-feature-medicines",
    transform: "translate(-5136 16482)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199375",
    "data-name": "Rectangle 199375",
    width: 300,
    height: 300,
    transform: "translate(5136 -16482)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_233404",
    "data-name": "Group 233404",
    transform: "translate(5139 -16482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233403",
    "data-name": "Group 233403",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233402",
    "data-name": "Group 233402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233401",
    "data-name": "Group 233401",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_423974",
    "data-name": "Path 423974",
    d: "M935.8,300a.583.583,0,0,1-.584-.579L933.168.588A.584.584,0,0,1,933.747,0h0a.584.584,0,0,1,.584.579l2.052,298.833a.583.583,0,0,1-.579.588Z",
    transform: "translate(-811.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423975",
    "data-name": "Path 423975",
    d: "M1174.927,86.1v131.9l128.8,21.075,1.077-132.79V54.16L1174.927,40.712V86.1Z",
    transform: "translate(-1021.676 -35.401)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423976",
    "data-name": "Path 423976",
    d: "M1299.834,235.742a.531.531,0,0,1-.095-.008l-128.8-21.074a.583.583,0,0,1-.489-.576V36.8a.581.581,0,0,1,.193-.433.54.54,0,0,1,.451-.147L1300.972,49.67a.583.583,0,0,1,.523.58v52.12l-1.077,132.794a.582.582,0,0,1-.583.579m-128.217-22.154,127.639,20.884,1.071-138.7v-45l-128.71-13.327Z",
    transform: "translate(-1017.783 -31.492)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423977",
    "data-name": "Path 423977",
    d: "M1380.838,249.716a.583.583,0,0,1-.583-.584V76.759a.584.584,0,1,1,1.167,0V249.133a.583.583,0,0,1-.584.584",
    transform: "translate(-1200.221 -66.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423978",
    "data-name": "Path 423978",
    d: "M1304.8,348.606v15.728L1174.927,346.1l23.04-10.383Z",
    transform: "translate(-1021.675 -291.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423979",
    "data-name": "Path 423979",
    d: "M1300.91,361.022a.658.658,0,0,1-.081-.006l-129.877-18.234a.584.584,0,0,1-.158-1.11l23.041-10.383a.552.552,0,0,1,.309-.047l106.837,12.888a.583.583,0,0,1,.514.579v15.728a.584.584,0,0,1-.583.584m-127.8-19.115,127.214,17.86V345.228L1194.164,332.42Z",
    transform: "translate(-1017.781 -288.032)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423980",
    "data-name": "Path 423980",
    d: "M1304.8,425.476v7.259L1174.927,416.06v-7.548Z",
    transform: "translate(-1021.675 -355.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423981",
    "data-name": "Path 423981",
    d: "M1296.546,917.647v15.728l-129.877-18.233,23.04-10.383Z",
    transform: "translate(-1014.495 -786.748)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423982",
    "data-name": "Path 423982",
    d: "M1292.651,930.056a.636.636,0,0,1-.081-.006l-129.877-18.232a.584.584,0,0,1-.158-1.11l23.041-10.384a.544.544,0,0,1,.309-.047l106.837,12.888a.583.583,0,0,1,.514.579v15.728a.584.584,0,0,1-.584.584m-127.8-19.114L1292.067,928.8V914.262l-106.162-12.807Z",
    transform: "translate(-1010.6 -782.844)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423983",
    "data-name": "Path 423983",
    d: "M1296.546,994.518v7.259L1166.669,985.1v-7.548Z",
    transform: "translate(-1014.495 -850.046)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423984",
    "data-name": "Path 423984",
    d: "M1296.546,1314.38v15.728l-129.877-18.233,23.04-10.383Z",
    transform: "translate(-1014.495 -1131.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423985",
    "data-name": "Path 423985",
    d: "M1292.651,1326.8a.672.672,0,0,1-.081-.006l-129.877-18.234a.583.583,0,0,1-.158-1.11l23.041-10.383a.577.577,0,0,1,.309-.047l106.837,12.887a.583.583,0,0,1,.514.579v15.729a.585.585,0,0,1-.584.584m-127.8-19.115,127.214,17.86v-14.54L1185.905,1298.2Z",
    transform: "translate(-1010.6 -1127.842)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423986",
    "data-name": "Path 423986",
    d: "M1296.546,1391.25v7.259l-129.877-16.675v-7.548Z",
    transform: "translate(-1014.495 -1195.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423987",
    "data-name": "Path 423987",
    d: "M1506.824,600.871l25.581,1.95.167-7.648-25.581-1.95Z",
    transform: "translate(-1310.281 -515.847)",
    fill: "#08f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423988",
    "data-name": "Path 423988",
    d: "M1535.452,593.471c0,.171-.309.309-.854.418-1.824.376-6.375.383-11.689-.022a58.785,58.785,0,0,1-11.578-1.731c-.591-.2-.92-.392-.917-.574.016-.739,5.635-.9,12.553-.374s12.5,1.543,12.485,2.283",
    transform: "translate(-1313.403 -513.808)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423989",
    "data-name": "Path 423989",
    d: "M1526.222,590.872c-2.075,0-4.582-.1-7.25-.3-5.187-.4-9.79-1.088-11.726-1.761-.65-.214-1.32-.52-1.309-1.138a.776.776,0,0,1,.266-.559c1.358-1.227,11.738-.475,12.916-.386,5.959.455,13.055,1.322,13.024,2.877-.015.718-.932.9-1.323.978a26.092,26.092,0,0,1-4.6.293m-18.391-3.1a82.809,82.809,0,0,0,22.424,1.724,85.795,85.795,0,0,0-22.424-1.724m23.145,1.806h0Z",
    transform: "translate(-1309.511 -509.926)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423990",
    "data-name": "Path 423990",
    d: "M1485.043,679.993c-.06,2.743.338,6.014-.5,8.612-.728,2.263-2.222,2.825-4.431,2.656l-18.224-1.389c-3.939-.3-7.888-.569-11.837-.9a6.539,6.539,0,0,1-3.854-1.281,2,2,0,0,1-.153-.151c-1.134-1.128-.957-2.531-.9-4,.083-2.848.125-5.7.187-8.561l.477-21.8c.054-2.475-.119-5.547.714-7.834,1.2-3.3,5.448-1.725,8-1.335a23.639,23.639,0,0,1,2.323.55,21.25,21.25,0,0,0,2.8.421c2.36.285,4.728.463,7.1.643,1.784.136,3.586.282,5.367.34,1.251.041,2.492-.077,3.742.019,1.531.117,3.061-.034,4.573.011,1.6.048,3.244-.149,4.5,1.184a3.783,3.783,0,0,1,.861,1.627c.359,1.508-.044,3.074-.144,4.566-.093,1.377-.071,2.774-.1,4.167Z",
    transform: "translate(-1256.604 -559.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423991",
    "data-name": "Path 423991",
    d: "M1476.928,687.982c-.258,0-.512-.012-.759-.031l-22.229-1.687c-2.609-.193-5.223-.385-7.836-.605a7.039,7.039,0,0,1-4.194-1.427,2.607,2.607,0,0,1-.2-.2c-1.189-1.181-1.126-2.623-1.066-4.018l.016-.385c.056-1.9.094-3.8.13-5.712l.535-24.644c.01-.458.013-.936.015-1.425a20.464,20.464,0,0,1,.734-6.6c1.176-3.233,4.711-2.5,7.292-1.968.479.1.933.193,1.342.255a17.09,17.09,0,0,1,1.861.424l.52.138a15.238,15.238,0,0,0,2.135.339l.592.068c2.3.277,4.654.456,6.93.629l.652.05c1.589.121,3.233.247,4.832.3.522.018,1.044.007,1.566-.006.714-.014,1.454-.031,2.2.025a25.128,25.128,0,0,0,2.586.023c.656-.016,1.312-.028,1.958-.013l.652.01c1.408.013,3,.026,4.256,1.358a4.337,4.337,0,0,1,1,1.892,9.808,9.808,0,0,1,0,3.5c-.051.415-.1.828-.129,1.235-.063.932-.072,1.875-.082,2.818,0,.441-.009.883-.018,1.323l-.491,22.457c-.016.724,0,1.485.018,2.262a20.19,20.19,0,0,1-.548,6.517,4.042,4.042,0,0,1-4.271,3.089m-30.983-47.994a2.575,2.575,0,0,0-2.778,1.662,19.684,19.684,0,0,0-.663,6.2c0,.5,0,.982-.015,1.445l-.535,24.641c-.038,1.912-.074,3.821-.13,5.727l-.016.4c-.055,1.246-.1,2.322.748,3.167a1.843,1.843,0,0,0,.135.135,6.04,6.04,0,0,0,3.51,1.131c2.608.22,5.218.411,7.824.6l22.231,1.687c2.185.17,3.256-.465,3.831-2.252a19.359,19.359,0,0,0,.491-6.133c-.017-.793-.034-1.572-.018-2.312l.491-22.457c.01-.437.014-.873.018-1.31.01-.966.021-1.93.084-2.884.028-.429.082-.862.135-1.3a8.8,8.8,0,0,0,.024-3.093,3.209,3.209,0,0,0-.719-1.361c-.911-.969-2.071-.978-3.415-.991l-.676-.01c-.632-.023-1.262,0-1.9.012-.881.019-1.791.043-2.7-.025a19.914,19.914,0,0,0-2.088-.023c-.542.01-1.087.022-1.63.006-1.624-.055-3.281-.181-4.882-.3l-.509-.039c-2.431-.186-4.8-.365-7.123-.646l-.581-.066a16.424,16.424,0,0,1-2.3-.368l-.532-.141a16.191,16.191,0,0,0-1.734-.4c-.427-.065-.9-.163-1.4-.266a16.621,16.621,0,0,0-3.181-.439",
    transform: "translate(-1252.708 -555.491)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423992",
    "data-name": "Path 423992",
    d: "M1487.377,746.852l-.383,17.518c-11.356-.436-29.129-1.48-39.745-3.76l.353-16.146c8.21.669,26.173,2.06,39.775,2.388",
    transform: "translate(-1258.477 -647.36)",
    fill: "#0095d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423993",
    "data-name": "Path 423993",
    d: "M1589.944,788.54l2.919.223.234-10.714-2.919-.222Z",
    transform: "translate(-1382.56 -676.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423994",
    "data-name": "Path 423994",
    d: "M1561.9,805.2l-.065,3,10.419.794.066-3Z",
    transform: "translate(-1358.12 -700.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199376",
    "data-name": "Rectangle 199376",
    width: 4.796,
    height: 3.391,
    transform: "matrix(0.065, -0.998, 0.998, 0.065, 203.33, 53.25)",
    fill: "#08f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423995",
    "data-name": "Path 423995",
    d: "M1507.68,367.142c.381-.044.987-.271,1.1.314a7.554,7.554,0,0,1,.167,1.077c.026.548.007,1.1,0,1.646a9.282,9.282,0,0,1-.119,1.441c-.058.355-.132,1.11-.426,1.364s-1.072-.049-1.443-.152c-.561-.155-1.11-.348-1.675-.492-1.022-.261-2.041-.533-3.045-.857-.9-.291-1.664-.418-1.965-1.439a1.771,1.771,0,0,1,.027-1.135c.517-1.294,2.169-1.173,3.311-1.3,1.355-.146,2.707-.315,4.061-.47",
    transform: "translate(-1304.523 -319.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423996",
    "data-name": "Path 423996",
    d: "M1896.209,389.546l4.158-.753,10.524,1.2.5-7.619L1900.8,382.2l-4.024-1.289Z",
    transform: "translate(-1648.878 -331.223)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423997",
    "data-name": "Path 423997",
    d: "M1907,386.691c-.022,0-.044,0-.066,0l-10.438-1.192-4.073.739a.593.593,0,0,1-.493-.139.586.586,0,0,1-.194-.473l.565-8.64a.585.585,0,0,1,.76-.519l3.942,1.262,10.506.18a.584.584,0,0,1,.572.621l-.5,7.618a.584.584,0,0,1-.583.546m-10.524-2.369c.021,0,.045,0,.066,0l9.915,1.132.42-6.4-9.979-.171a.6.6,0,0,1-.168-.027l-3.313-1.061-.468,7.149,3.422-.62a.616.616,0,0,1,.1-.009",
    transform: "translate(-1644.986 -327.336)",
    fill: "#08f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199377",
    "data-name": "Rectangle 199377",
    width: 11.894,
    height: 39.146,
    transform: "matrix(0.065, -0.998, 0.998, 0.065, 206.465, 57.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423998",
    "data-name": "Path 423998",
    d: "M1618.063,359.159h-.038l-39.063-2.558a.583.583,0,0,1-.545-.62l.778-11.868a.569.569,0,0,1,.62-.545l39.063,2.558a.583.583,0,0,1,.545.62l-.777,11.868a.584.584,0,0,1-.583.546m-38.443-3.685,37.9,2.482.7-10.7-37.9-2.482Z",
    transform: "translate(-1372.536 -298.749)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423999",
    "data-name": "Path 423999",
    d: "M1883.143,353.207a1.5,1.5,0,0,0,.255-.326,2.134,2.134,0,0,0,.3-1.055l.261-3.994.33-5.041q.163-2.488.326-4.977c.126-.172.053-.814.068-1.036l.074-1.122c.046-.7.355-1.524.037-2.2a1.812,1.812,0,0,0-1.547-1.025c-1.828.107-1.423,3.47-1.5,4.658l-.337,5.147-.347,5.3q-.075,1.155-.151,2.309c-.067,1.023-.468,2.5.431,3.287a1.536,1.536,0,0,0,1.418.3,1.151,1.151,0,0,0,.379-.237",
    transform: "translate(-1635.45 -289.072)",
    fill: "#0095d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199378",
    "data-name": "Rectangle 199378",
    width: 10.071,
    height: 3.372,
    transform: "matrix(0.065, -0.998, 0.998, 0.065, 229.117, 57.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424000",
    "data-name": "Path 424000",
    d: "M1797.371,411.01h-.039a.584.584,0,0,1-.545-.62l.219-3.349a.608.608,0,0,1,.62-.545.584.584,0,0,1,.545.62l-.219,3.349a.584.584,0,0,1-.581.546",
    transform: "translate(-1562.422 -353.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424001",
    "data-name": "Path 424001",
    d: "M1733.213,411.1h-.04a.584.584,0,0,1-.544-.621l.22-3.35a.561.561,0,0,1,.621-.544.584.584,0,0,1,.544.621l-.22,3.35a.584.584,0,0,1-.581.545",
    transform: "translate(-1506.633 -353.552)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424002",
    "data-name": "Path 424002",
    d: "M1703.97,410.012h-.039a.584.584,0,0,1-.545-.62l.219-3.349a.6.6,0,0,1,.62-.545.584.584,0,0,1,.545.62l-.219,3.349a.584.584,0,0,1-.581.546",
    transform: "translate(-1481.204 -352.603)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424003",
    "data-name": "Path 424003",
    d: "M1674.717,408.928h-.039a.584.584,0,0,1-.544-.621l.22-3.35a.584.584,0,1,1,1.165.078l-.22,3.35a.584.584,0,0,1-.583.545",
    transform: "translate(-1455.768 -351.661)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424004",
    "data-name": "Path 424004",
    d: "M1645.475,407.848h-.039a.584.584,0,0,1-.545-.62l.219-3.349a.611.611,0,0,1,.62-.545.584.584,0,0,1,.545.62l-.219,3.349a.584.584,0,0,1-.581.546",
    transform: "translate(-1430.339 -350.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424005",
    "data-name": "Path 424005",
    d: "M1821.65,396.972h-.039a.584.584,0,0,1-.545-.62l.373-5.7a.617.617,0,0,1,.62-.545.584.584,0,0,1,.545.62l-.373,5.7a.584.584,0,0,1-.581.546",
    transform: "translate(-1583.534 -339.227)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_824",
    "data-name": "Line 824",
    x1: 19.99,
    y1: 2.523,
    transform: "translate(175.646 47.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424006",
    "data-name": "Path 424006",
    d: "M1362.724,363.826a.543.543,0,0,1-.074,0l-19.989-2.523a.584.584,0,0,1,.146-1.158l19.989,2.523a.584.584,0,0,1-.072,1.163",
    transform: "translate(-1167.087 -313.162)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_233394",
    "data-name": "Group 233394",
    transform: "translate(207.46 46.658)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233393",
    "data-name": "Group 233393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233392",
    "data-name": "Group 233392",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424007",
    "data-name": "Path 424007",
    d: "M1590.533,367.311l.023-.257.836-9.347,22.115,1.281-.806,10.04",
    transform: "translate(-1590.533 -357.707)",
    fill: "#08f"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_424008",
    "data-name": "Path 424008",
    d: "M1995.781,364.424a23.536,23.536,0,0,0-.183-5.048,6.235,6.235,0,0,0-.467-1.85c-.23-.446-.219-1.388.561-1.252a3.99,3.99,0,0,0-1.953-.022c-.741.244-1.063,1.126-1.324,1.8a20.181,20.181,0,0,0-1.149,6.106,17.732,17.732,0,0,0,.616,6.859,2.2,2.2,0,0,0,.931,1.346c.188.084,1.742.833,1.8.513.012-.073-.141-.261-.176-.328-.261-.487-.45-.886-.122-1.37a5.106,5.106,0,0,0,.566-1.343,20.245,20.245,0,0,0,.746-3.638q.107-.882.159-1.769",
    transform: "translate(-1731.473 -309.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424009",
    "data-name": "Path 424009",
    d: "M2006.48,365.75c.267-4.487-.527-8.186-1.775-8.26s-2.475,3.5-2.742,7.991.527,8.186,1.774,8.26,2.475-3.5,2.742-7.991",
    transform: "translate(-1740.792 -310.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424010",
    "data-name": "Path 424010",
    d: "M1999.886,370.434l-.074,0c-.915-.055-1.586-1.042-1.993-2.934a23.092,23.092,0,0,1-.331-5.944c.246-4.14,1.377-8.54,3.284-8.54l.074,0c.915.055,1.586,1.042,1.992,2.934a23.043,23.043,0,0,1,.332,5.943c-.246,4.141-1.377,8.542-3.284,8.542m.883-16.253c-.508,0-1.822,2.5-2.116,7.443a21.893,21.893,0,0,0,.307,5.628c.355,1.649.816,2.009.92,2.015h.009c.509,0,1.822-2.5,2.116-7.443a21.881,21.881,0,0,0-.308-5.628c-.353-1.65-.815-2.009-.919-2.015Z",
    transform: "translate(-1736.901 -306.968)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199380",
    "data-name": "Rectangle 199380",
    width: 3.391,
    height: 4.796,
    transform: "translate(205.652 36.311) rotate(-6)",
    fill: "#08f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424011",
    "data-name": "Path 424011",
    d: "M1525.683,273.893c.368-.108.927-.434,1.141.122a7.584,7.584,0,0,1,.347,1.033c.118.536.192,1.081.282,1.622a9.251,9.251,0,0,1,.127,1.441c0,.36.058,1.116-.189,1.417s-1.065.133-1.448.094c-.579-.058-1.153-.155-1.734-.2-1.051-.084-2.1-.18-3.146-.329-.937-.134-1.711-.13-2.181-1.086a1.772,1.772,0,0,1-.166-1.123c.29-1.363,1.939-1.524,3.044-1.838,1.311-.373,2.615-.768,3.923-1.151",
    transform: "translate(-1320.596 -238)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424012",
    "data-name": "Path 424012",
    d: "M1913.537,231.932l3.97-1.446,10.576-.6-.8-7.593-10.469,1.615-4.184-.589Z",
    transform: "translate(-1663.158 -193.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424013",
    "data-name": "Path 424013",
    d: "M1909.645,228.634a.585.585,0,0,1-.58-.522l-.905-8.611a.582.582,0,0,1,.174-.481.6.6,0,0,1,.487-.158l4.1.577,10.383-1.6a.6.6,0,0,1,.445.114.583.583,0,0,1,.225.4l.8,7.593a.583.583,0,0,1-.547.644l-10.49.593-3.89,1.417a.578.578,0,0,1-.2.035m-.246-8.513.749,7.126,3.268-1.191a.6.6,0,0,1,.166-.034l9.965-.563-.67-6.375-9.863,1.522a.567.567,0,0,1-.17,0Z",
    transform: "translate(-1659.266 -189.418)",
    fill: "#08f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199381",
    "data-name": "Rectangle 199381",
    width: 39.146,
    height: 11.893,
    transform: "translate(208.68 32.682) rotate(-6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424014",
    "data-name": "Path 424014",
    d: "M1597.234,231.792a.584.584,0,0,1-.58-.523l-1.242-11.828a.582.582,0,0,1,.519-.641l38.931-4.091a.576.576,0,0,1,.642.519l1.244,11.828a.583.583,0,0,1-.519.642l-38.932,4.091a.575.575,0,0,1-.062,0m-.6-11.892,1.121,10.667,37.77-3.969-1.122-10.667Z",
    transform: "translate(-1387.311 -186.699)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424015",
    "data-name": "Path 424015",
    d: "M1900.01,202.825a1.5,1.5,0,0,0,.2-.365,2.132,2.132,0,0,0,.119-1.091l-.418-3.98-.528-5.024q-.261-2.48-.521-4.96c.095-.191-.085-.812-.108-1.032q-.059-.559-.118-1.119c-.073-.7.092-1.562-.335-2.171a1.812,1.812,0,0,0-1.7-.748c-1.784.415-.815,3.661-.69,4.845l.539,5.13q.278,2.642.556,5.285l.242,2.3c.107,1.02-.039,2.539.981,3.167a1.537,1.537,0,0,0,1.45.06,1.154,1.154,0,0,0,.334-.3",
    transform: "translate(-1648.292 -158.527)",
    fill: "#0095d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199382",
    "data-name": "Rectangle 199382",
    width: 3.372,
    height: 10.071,
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 231.31, 31.326)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424016",
    "data-name": "Path 424016",
    d: "M1817.979,276.349a.583.583,0,0,1-.579-.522l-.351-3.339a.584.584,0,1,1,1.161-.123l.351,3.339a.582.582,0,0,1-.519.642.619.619,0,0,1-.063,0",
    transform: "translate(-1580.04 -236.386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424017",
    "data-name": "Path 424017",
    d: "M1754.774,287.284a.583.583,0,0,1-.579-.522l-.351-3.339a.582.582,0,0,1,.519-.642.576.576,0,0,1,.642.519l.351,3.339a.582.582,0,0,1-.519.642.608.608,0,0,1-.063,0",
    transform: "translate(-1525.078 -245.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424018",
    "data-name": "Path 424018",
    d: "M1725.758,291.166a.583.583,0,0,1-.579-.522l-.351-3.338a.582.582,0,0,1,.519-.642.571.571,0,0,1,.642.519l.351,3.338a.582.582,0,0,1-.519.642.61.61,0,0,1-.063,0",
    transform: "translate(-1499.847 -249.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424019",
    "data-name": "Path 424019",
    d: "M1696.751,295.039a.583.583,0,0,1-.579-.522l-.351-3.339a.583.583,0,1,1,1.16-.123l.351,3.339a.582.582,0,0,1-.519.642.6.6,0,0,1-.063,0",
    transform: "translate(-1474.624 -252.636)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424020",
    "data-name": "Path 424020",
    d: "M1667.744,298.922a.583.583,0,0,1-.579-.522l-.351-3.339a.582.582,0,0,1,.519-.642.573.573,0,0,1,.642.519l.351,3.339a.582.582,0,0,1-.519.642.612.612,0,0,1-.063,0",
    transform: "translate(-1449.401 -256.013)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424021",
    "data-name": "Path 424021",
    d: "M1840.546,258.22a.583.583,0,0,1-.579-.523l-.6-5.676a.583.583,0,1,1,1.16-.121l.6,5.676a.582.582,0,0,1-.52.641.573.573,0,0,1-.062,0",
    transform: "translate(-1599.45 -218.588)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_825",
    "data-name": "Line 825",
    x1: 20.128,
    y2: 0.898,
    transform: "translate(177.906 39.259)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424022",
    "data-name": "Path 424022",
    d: "M1360.058,298.529a.583.583,0,0,1-.026-1.166l20.128-.9a.538.538,0,0,1,.609.556.582.582,0,0,1-.556.609l-20.128.9h-.026",
    transform: "translate(-1182.152 -257.788)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_233397",
    "data-name": "Group 233397",
    transform: "translate(209.954 31.256)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233396",
    "data-name": "Group 233396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233395",
    "data-name": "Group 233395",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424023",
    "data-name": "Path 424023",
    d: "M1610.434,251.726l-.021-.257-.758-9.353,22.013-2.482.906,10.031",
    transform: "translate(-1609.654 -239.633)",
    fill: "#08f"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_424024",
    "data-name": "Path 424024",
    d: "M2011.936,193.623a23.543,23.543,0,0,0-1.035-4.944,6.233,6.233,0,0,0-.774-1.744c-.3-.4-.451-1.331.341-1.329a3.991,3.991,0,0,0-1.929.309c-.689.365-.856,1.29-1,1.995a20.178,20.178,0,0,0-.1,6.212,17.735,17.735,0,0,0,1.768,6.655c.251.447.61,1.033,1.146,1.169.2.051,1.858.526,1.857.2,0-.074-.183-.234-.229-.293-.34-.436-.594-.8-.353-1.33a5.107,5.107,0,0,0,.331-1.419,20.258,20.258,0,0,0,.119-3.712q-.043-.887-.142-1.77",
    transform: "translate(-1745.433 -161.396)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424025",
    "data-name": "Path 424025",
    d: "M2022.672,194.118c-.5-4.468-1.905-7.978-3.147-7.84s-1.846,3.872-1.35,8.34,1.905,7.978,3.147,7.84,1.846-3.872,1.35-8.34",
    transform: "translate(-1754.784 -161.977)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424026",
    "data-name": "Path 424026",
    d: "M2017.353,199.162c-.855,0-1.634-.862-2.316-2.564a23.094,23.094,0,0,1-1.333-5.8c-.463-4.176-.078-8.768,1.865-8.984,1.962-.2,3.329,4.179,3.793,8.356h0c.463,4.176.077,8.769-1.865,8.984a1.249,1.249,0,0,1-.144.008m-1.637-16.19h-.017c-.5.055-1.384,2.74-.834,7.7a21.839,21.839,0,0,0,1.255,5.494c.627,1.565,1.15,1.819,1.248,1.831.5-.055,1.384-2.741.833-7.7-.545-4.9-1.972-7.325-2.485-7.325",
    transform: "translate(-1750.893 -158.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424027",
    "data-name": "Path 424027",
    d: "M743.758,1127.687c.721-1.136.662-3.084.584-4.669-.523-10.578-.755-21.385-1.232-32.109a230.233,230.233,0,0,1,.064-23.117,107.3,107.3,0,0,1,1.159-11.682c1.057-6.448,1.4-11.315,4.827-17.053a24.46,24.46,0,0,1,12.91-10.849c7.351-2.538,15.312-1.28,22.874-.856,7.472.419,16.521.977,23.416,3.7,25.64,10.125,15.845,52.4,12.532,72.529-1.778,10.8-2.587,25.659-2.587,36.6",
    transform: "translate(-645.957 -892.751)",
    fill: "#0095d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424028",
    "data-name": "Path 424028",
    d: "M298.671,1058.983l-34.284,41.126-47.755,1.855v24.782l44.629-.622s20.8,3.02,28.522-13.087",
    transform: "translate(-188.376 -920.855)",
    fill: "#0095d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424029",
    "data-name": "Path 424029",
    d: "M1021.4,932.181l-.871,16.5a2.786,2.786,0,0,1-1.969,2.491c-3.233,1.024-9.975,2.548-14.8-.547a2.686,2.686,0,0,1-1.218-2.409l.636-12.061",
    transform: "translate(-871.773 -810.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424030",
    "data-name": "Path 424030",
    d: "M1006.97,949.171a13.6,13.6,0,0,1-7.412-1.938,3.271,3.271,0,0,1-1.485-2.931l.636-12.061a.583.583,0,1,1,1.165.062l-.636,12.061a2.106,2.106,0,0,0,.949,1.887c4.556,2.919,10.923,1.554,14.311.482a2.22,2.22,0,0,0,1.564-1.965l.871-16.5a.6.6,0,0,1,.613-.552.583.583,0,0,1,.552.613l-.871,16.5a3.391,3.391,0,0,1-2.376,3.016,26.909,26.909,0,0,1-7.882,1.326",
    transform: "translate(-867.885 -806.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424031",
    "data-name": "Path 424031",
    d: "M943.314,686.589c6.5-3.681,10.828-11.267,10.569-19.948-.362-12.123-9.533-21.79-20.485-21.591s-19.536,10.187-19.174,22.31c.349,11.7,8.9,21.106,19.335,21.576",
    transform: "translate(-794.968 -560.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424032",
    "data-name": "Path 424032",
    d: "M929.669,685.622h-.026c-10.8-.486-19.536-10.212-19.892-22.141a23.447,23.447,0,0,1,6.217-16.834,19.114,19.114,0,0,1,13.53-6.077c.113,0,.227,0,.34,0,11.1,0,20.371,9.865,20.739,22.162.259,8.686-3.9,16.532-10.866,20.474a.584.584,0,1,1-.575-1.017c6.583-3.728,10.52-11.169,10.273-19.423-.352-11.785-9.245-21.18-19.891-21.025a17.954,17.954,0,0,0-12.706,5.716,22.266,22.266,0,0,0-5.895,15.994c.337,11.322,8.585,20.551,18.777,21.01a.583.583,0,0,1-.026,1.166",
    transform: "translate(-791.078 -557.013)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424033",
    "data-name": "Path 424033",
    d: "M993.338,839.734a2.964,2.964,0,0,1-.513-.044,2.44,2.44,0,0,1-1.984-1.717,2.86,2.86,0,0,1,.511-2.207c.1-.164.213-.326.325-.487a4.771,4.771,0,0,0,.581-1.007,4.71,4.71,0,0,0,.174-1.65.584.584,0,0,1,.578-.589h.006a.584.584,0,0,1,.584.578,4.487,4.487,0,0,1-.961,3.328c-.1.148-.2.3-.3.446a1.784,1.784,0,0,0-.367,1.307,1.3,1.3,0,0,0,1.051.848,2.41,2.41,0,0,0,1.62-.376.583.583,0,1,1,.613.992,3.668,3.668,0,0,1-1.921.578",
    transform: "translate(-861.549 -723.508)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424034",
    "data-name": "Path 424034",
    d: "M827.231,496.151c.218-.265.435-.534.653-.8,3.943-4.867,8.636-10.75,14.3-13.629a22.447,22.447,0,0,1,21.891.767,41.03,41.03,0,0,1,9.139,6.777c1.953,2.02,3.342,5.133,6.193,5.358,2.317.182,4.245-.242,6.486.79,4.263,1.965,6.126,6.607,6.387,11.05.432,7.362-4.279,12.754-7.938,18.642-2.73,4.393-6.744,7.389-11.033,10.136-1.476.945-9.063,5.612-8.9,1.189.083-2.215,2.686-4.753,3.785-6.583,1.642-2.735,3.268-6.137-.313-7.6-2.965-1.214-4.443-1.147-6.585-4.013,0,0,.2.192.231.143a19.089,19.089,0,0,1-1.752-4.429c-.591-2.277-.036-2.96-2.674-3.139-3.358-.228-6.723.48-9.979-.238a29.255,29.255,0,0,1-7.883-2.66c-1.924-1.153-2.889-2.293-4.712.085-1.337,1.745-1.677,4.013-3.147,5.828-.921,1.137-.592,1-2.145.977a8.86,8.86,0,0,1-5.044-2,20.8,20.8,0,0,1-5.24-5.031c-.272-.4-2.49-5.948-2.146-5.964a3.574,3.574,0,0,0,1.151-.09c1.6-.84,3.613-1.049,5.268-1.95a13.825,13.825,0,0,0,4-3.614",
    transform: "translate(-710.242 -416.725)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424035",
    "data-name": "Path 424035",
    d: "M1046.259,772.852a.583.583,0,0,1-.343-.112,6.738,6.738,0,0,0-6.815-.385.583.583,0,0,1-.563-1.021,7.854,7.854,0,0,1,8.064.463.584.584,0,0,1-.343,1.056",
    transform: "translate(-902.814 -669.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424036",
    "data-name": "Path 424036",
    d: "M952.306,772.245a.581.581,0,0,1-.343-.112,6.736,6.736,0,0,0-6.814-.384.583.583,0,1,1-.563-1.022,7.868,7.868,0,0,1,8.063.462.584.584,0,0,1-.343,1.055",
    transform: "translate(-821.117 -669.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424037",
    "data-name": "Path 424037",
    d: "M1207.016,805.645a3.744,3.744,0,0,1,3.146-.937,3.584,3.584,0,0,1,2.405,1.532c1.8,2.79.838,7.161-2.319,8.582a7.173,7.173,0,0,1-4.022.483",
    transform: "translate(-1048.893 -699.702)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424038",
    "data-name": "Path 424038",
    d: "M1203.539,812.1a8.371,8.371,0,0,1-1.293-.1.584.584,0,0,1-.487-.667.591.591,0,0,1,.667-.487,6.567,6.567,0,0,0,3.692-.438,4.875,4.875,0,0,0,2.629-3.163,5.6,5.6,0,0,0-.561-4.57,3,3,0,0,0-2.012-1.272,3.155,3.155,0,0,0-2.647.784.584.584,0,1,1-.8-.846,4.342,4.342,0,0,1,3.647-1.09,4.185,4.185,0,0,1,2.8,1.792,6.78,6.78,0,0,1,.7,5.533,6.1,6.1,0,0,1-3.269,3.9,7.507,7.507,0,0,1-3.058.628",
    transform: "translate(-1045.002 -695.822)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424039",
    "data-name": "Path 424039",
    d: "M1212.373,833.586a.667.667,0,0,1-.486-.218.584.584,0,0,1,.066-.823l.022-.017a1.027,1.027,0,0,0-.033-.619,1.135,1.135,0,0,0-.572-.6.584.584,0,1,1,.495-1.058,2.307,2.307,0,0,1,1.167,1.241,2.176,2.176,0,0,1-.057,1.691.806.806,0,0,1-.535.4c-.022,0-.045,0-.067,0",
    transform: "translate(-1053.073 -721.907)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_233400",
    "data-name": "Group 233400",
    transform: "translate(122.613 69.648)",
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233399",
    "data-name": "Group 233399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233398",
    "data-name": "Group 233398",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424040",
    "data-name": "Path 424040",
    d: "M944.268,533.967l.6.86,1.584,2.285c.241.348.522.691.732,1.057.113.2.1.408.306.551a1.227,1.227,0,0,0,.886.09c.606-.079,1.229-.1,1.839-.144l1.531-.12.69-.054a3.511,3.511,0,0,1,.75-.045,2.684,2.684,0,0,1,.4.123,1.234,1.234,0,0,1,.646.632c.248.394.558.764.838,1.138.292.389.587.776.891,1.156.132.165.295.324.41.5.153.232.262.493.571.581a5.524,5.524,0,0,0,1.422.026c.575-.007,1.149-.021,1.724-.037q1.826-.05,3.65-.123l-2.794,1.759-2.379,1.5c-.343.216-1.093.752-1.436.968-.326.205-.755.587-1.171.469a.993.993,0,0,1-.3-.146c-.658-.458-.77-1.542-1.3-2.135l-2.7-3.029-1.859.694-1.514.565c-.214.08-.427.118-.643.183-.257.077-.424.219-.706.107a1.5,1.5,0,0,1-.666-.439c-.1-.124-.2-.244-.3-.364l-.649-.772-3.4-4.046-1.894-2.253Z",
    transform: "translate(-940.033 -533.967)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_424041",
    "data-name": "Path 424041",
    d: "M962.43,801.825c-.133,1.344.408,2.5,1.21,2.578s1.56-.946,1.693-2.29-.408-2.5-1.21-2.578-1.56.946-1.693,2.29",
    transform: "translate(-836.878 -695.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424042",
    "data-name": "Path 424042",
    d: "M1055.924,807.145c-.133,1.344.408,2.5,1.21,2.578s1.56-.946,1.693-2.29-.408-2.5-1.21-2.578-1.56.946-1.693,2.29",
    transform: "translate(-918.178 -699.87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424043",
    "data-name": "Path 424043",
    d: "M1016.726,919.8a6.927,6.927,0,0,1-2.875-.674.584.584,0,1,1,.486-1.062,4.673,4.673,0,0,0,5.829-1.013.714.714,0,0,1,.608-.3.584.584,0,0,1,.291,1.047,5.882,5.882,0,0,1-4.338,2",
    transform: "translate(-881.313 -797.179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424044",
    "data-name": "Path 424044",
    d: "M1159.242,1035.042c27.464-2.628,37.657,31.267,40.771,52.453a221.351,221.351,0,0,1,2.229,31.893c0,10.682-2.059,20.869-2.962,31.173-3.646.621-8.445-1.327-12.219-1.7-1.614-.16-5.016-.034-6.414-.882-1.532-.931-1.61-2.15-1.767-4.351-.623-8.739-.874-17.513-.859-26.291",
    transform: "translate(-1008.036 -899.911)",
    fill: "#0095d9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_826",
    "data-name": "Line 826",
    x1: 293.07,
    y1: 51.946,
    transform: "translate(0.584 216.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424045",
    "data-name": "Path 424045",
    d: "M293.654,1712.195a.522.522,0,0,1-.1-.009L.482,1660.241a.583.583,0,0,1,.2-1.149l293.069,51.944a.584.584,0,0,1-.1,1.158",
    transform: "translate(0 -1442.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424046",
    "data-name": "Path 424046",
    d: "M1259.9,1329.635c.9,2.227-.647,64.128-.647,64.128",
    transform: "translate(-1095.003 -1156.204)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424047",
    "data-name": "Path 424047",
    d: "M1255.361,1390.55h-.015a.584.584,0,0,1-.569-.6c.618-24.646,1.31-62,.686-63.9a.6.6,0,0,1,.349-.744.572.572,0,0,1,.735.313c.923,2.274-.445,58.016-.6,64.363a.583.583,0,0,1-.584.57",
    transform: "translate(-1091.11 -1152.407)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424048",
    "data-name": "Path 424048",
    d: "M1292.861,1815.578c-1.395,3.56-4,5.86-5.911,5.385-1.036-.257-1.715-1.272-1.948-2.7-1.038,1.115-2.209,1.671-3.245,1.414s-1.763-1.284-2.08-2.742c-.962,1.141-2.084,1.709-3.12,1.451a3.5,3.5,0,0,1-2.2-2.765c-.882,1.153-1.956,1.733-2.992,1.476-1.913-.475-3.139-3.724-2.708-7.523.468-4.12,2.682-7.3,4.906-6.745,1.2.3,2.1,1.641,2.517,3.481,1.028-1.48,2.315-2.281,3.519-1.983s2.037,1.635,2.352,3.448c1.126-1.455,2.48-2.249,3.692-1.948s1.967,1.609,2.191,3.4c1.225-1.431,2.641-2.2,3.845-1.9,2.224.552,2.7,4.4,1.183,8.257",
    transform: "translate(-1103.104 -1567.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424049",
    "data-name": "Path 424049",
    d: "M1283.57,1817.726a2.665,2.665,0,0,1-.66-.08,3.131,3.131,0,0,1-2.131-2.168,3.532,3.532,0,0,1-3.062.88,3.041,3.041,0,0,0-5.2-1.291,3.52,3.52,0,0,1-2.291-2.209,3.143,3.143,0,0,1-2.9.921c-2.258-.559-3.611-4.065-3.146-8.155.342-3.014,1.57-5.59,3.2-6.726a2.955,2.955,0,0,1,2.423-.521,4.106,4.106,0,0,1,2.62,2.819,3.55,3.55,0,0,1,3.418-1.32,3.352,3.352,0,0,0,6.042,1.5,3.566,3.566,0,0,1,2.406,2.763,4.1,4.1,0,0,1,3.631-1.265,2.927,2.927,0,0,1,1.9,1.591c.914,1.767.794,4.619-.311,7.444-1.36,3.468-3.81,5.816-5.937,5.816m-2.467-3.93a.6.6,0,0,1,.169.025.581.581,0,0,1,.407.465c.2,1.229.752,2.041,1.513,2.228,1.434.365,3.833-1.466,5.228-5.027.972-2.485,1.115-5.029.362-6.484a1.782,1.782,0,0,0-1.142-1c-.934-.226-2.146.413-3.261,1.717a.594.594,0,0,1-.611.178.584.584,0,0,1-.411-.486c-.2-1.6-.856-2.683-1.753-2.907-.914-.224-2.07.422-3.089,1.742a.573.573,0,0,1-.6.208.579.579,0,0,1-.434-.465c-.285-1.641-1-2.756-1.917-2.982-.9-.226-1.983.431-2.9,1.749a.584.584,0,0,1-1.048-.2c-.383-1.676-1.164-2.814-2.088-3.045a1.8,1.8,0,0,0-1.476.347c-1.345.936-2.409,3.25-2.709,5.9-.433,3.8.84,6.536,2.267,6.892.757.182,1.628-.273,2.388-1.268a.594.594,0,0,1,.578-.216.583.583,0,0,1,.45.422c.344,1.3.992,2.155,1.778,2.351a2.742,2.742,0,0,0,2.532-1.263.566.566,0,0,1,.587-.189.578.578,0,0,1,.43.442c.276,1.268.878,2.107,1.652,2.3a3,3,0,0,0,2.675-1.245.584.584,0,0,1,.427-.187m7.86-2.1h0Z",
    transform: "translate(-1099.205 -1563.739)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_827",
    "data-name": "Line 827",
    x1: 2.831,
    y2: 9.037,
    transform: "translate(181.898 241.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424050",
    "data-name": "Path 424050",
    d: "M1390.658,1858.019a.586.586,0,0,1-.557-.759l2.832-9.038a.584.584,0,0,1,1.115.351l-2.832,9.037a.585.585,0,0,1-.557.408",
    transform: "translate(-1208.76 -1606.796)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_828",
    "data-name": "Line 828",
    x1: 2.273,
    y2: 9.16,
    transform: "translate(176.574 240.152)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424051",
    "data-name": "Path 424051",
    d: "M1349.836,1847a.5.5,0,0,1-.14-.018.582.582,0,0,1-.426-.707l2.273-9.158a.574.574,0,0,1,.707-.424.582.582,0,0,1,.426.707l-2.273,9.158a.585.585,0,0,1-.567.442",
    transform: "translate(-1173.263 -1597.106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424052",
    "data-name": "Path 424052",
    d: "M1313.9,1830.889c-.093-.023-1.714,9.309-1.714,9.309",
    transform: "translate(-1141.028 -1592.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424053",
    "data-name": "Path 424053",
    d: "M1308.292,1837.53a.508.508,0,0,1-.1-.009.583.583,0,0,1-.474-.675c1.647-9.487,1.684-9.51,1.968-9.7l.32.488-.137.568.138-.568.54.21c-.136.436-1.1,5.873-1.68,9.2a.583.583,0,0,1-.573.483",
    transform: "translate(-1137.137 -1588.826)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199385",
    "data-name": "Rectangle 199385",
    width: 24.028,
    height: 6.986,
    transform: "translate(17.53 162.271)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424054",
    "data-name": "Path 424054",
    d: "M160.138,1238.461c0,.156-.284.3-.793.44a54.388,54.388,0,0,1-10.961.793,55.615,55.615,0,0,1-10.893-.773c-.558-.137-.871-.294-.871-.46,0-.675,5.266-1.214,11.764-1.214s11.754.538,11.754,1.214",
    transform: "translate(-118.8 -1075.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424055",
    "data-name": "Path 424055",
    d: "M144.491,1236.386a56.255,56.255,0,0,1-11.042-.792c-.418-.1-1.306-.32-1.306-1.025,0-1.193,4.154-1.8,12.348-1.8s12.338.6,12.338,1.8c0,.675-.826.9-1.224,1a54.787,54.787,0,0,1-11.113.813m-10.293-1.817a62.323,62.323,0,0,0,10.293.65,63.189,63.189,0,0,0,10.286-.65,64.521,64.521,0,0,0-10.286-.629,64.641,64.641,0,0,0-10.293.629m21.585.3h0Z",
    transform: "translate(-114.907 -1071.976)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424056",
    "data-name": "Path 424056",
    d: "M120.1,1322.457c0,2.506.44,5.461-.294,7.889-.636,2.114-2.026,2.73-4.1,2.73H98.59c-3.7,0-7.409.029-11.118,0a6.01,6.01,0,0,1-3.641-.9,1.68,1.68,0,0,1-.147-.127c-1.086-.949-.949-2.241-.93-3.582.02-2.6,0-5.207,0-7.82v-19.917c0-2.261-.225-5.05.509-7.193,1.059-3.092,5.074-1.952,7.472-1.774a22.148,22.148,0,0,1,2.19.34,20.138,20.138,0,0,0,2.637.189c2.219.1,4.444.093,6.668.093,1.676,0,3.368.008,5.04-.063,1.174-.049,2.335-.243,3.51-.243,1.438,0,2.869-.244,4.289-.307,1.5-.068,3.039-.362,4.243.767a3.209,3.209,0,0,1,.841,1.423,13.57,13.57,0,0,1-.042,4.174c-.059,1.263-.01,2.535-.01,3.807Z",
    transform: "translate(-71.932 -1122.966)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424057",
    "data-name": "Path 424057",
    d: "M87.289,1329.794q-1.855,0-3.713-.014a6.5,6.5,0,0,1-3.994-1.024,2.475,2.475,0,0,1-.2-.17c-1.171-1.022-1.139-2.42-1.112-3.655l.007-.353c.013-1.728.009-3.461,0-5.2l0-22.531c0-.416-.008-.852-.016-1.3a18.509,18.509,0,0,1,.556-6.086c1.039-3.033,4.374-2.611,6.808-2.306.449.057.875.111,1.26.139a15.834,15.834,0,0,1,1.744.256l.5.091a14.334,14.334,0,0,0,2,.16l.562.021c2.155.092,4.368.069,6.491.094h.565c1.536.007,3.077,0,4.6-.063.489-.02.977-.067,1.464-.114,1.44-.138,3-.144,4.5-.29.613-.059,1.225-.118,1.834-.146l.608-.036c1.326-.091,2.836-.188,4.061.96a3.763,3.763,0,0,1,1.005,1.7,8.713,8.713,0,0,1,.074,3.217c-.039.383-.079.763-.1,1.135-.04.858-.03,1.72-.018,2.583l.009,1.2v20.514c0,.661.031,1.354.063,2.061a18.185,18.185,0,0,1-.382,6c-.839,2.787-2.931,3.145-4.659,3.145L91,1329.787q-1.855.005-3.712.007m-6.991-1.958a5.514,5.514,0,0,0,3.288.777c2.474.022,4.945.015,7.412.007l20.819-.007c2.047,0,3.04-.649,3.542-2.315a17.379,17.379,0,0,0,.333-5.606c-.032-.724-.064-1.435-.064-2.114l-.009-21.7c-.011-.887-.022-1.771.02-2.651.017-.394.058-.8.1-1.2a7.723,7.723,0,0,0-.039-2.793,2.626,2.626,0,0,0-.677-1.15c-.855-.8-1.934-.733-3.186-.647l-.632.036c-.589.027-1.18.085-1.773.144-1.459.14-3,.144-4.5.29-.508.048-1.016.1-1.526.119-1.547.064-3.113.063-4.652.063h-.564c-2.149,0-4.36,0-6.541-.094l-.551-.021a15.417,15.417,0,0,1-2.162-.178l-.514-.093a14.623,14.623,0,0,0-1.618-.238c-.4-.031-.849-.087-1.32-.146-2.732-.345-4.88-.453-5.558,1.526a17.73,17.73,0,0,0-.492,5.687c.008.451.016.894.016,1.317l0,22.528c0,1.74.008,3.477,0,5.213l-.007.367c-.03,1.294-.009,2.12.736,2.772l-.237.565Z",
    transform: "translate(-68.041 -1119.087)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424058",
    "data-name": "Path 424058",
    d: "M120.319,1381.538v16c-10.658.391-27.345.675-37.348-.666v-14.749c7.712.039,24.585.059,37.348-.587",
    transform: "translate(-72.149 -1201.337)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199386",
    "data-name": "Rectangle 199386",
    width: 2.742,
    height: 9.787,
    transform: "translate(28.254 183.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199387",
    "data-name": "Rectangle 199387",
    width: 9.787,
    height: 2.742,
    transform: "translate(24.731 186.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199388",
    "data-name": "Rectangle 199388",
    width: 17.112,
    height: 4.975,
    transform: "translate(80.489 250.173)",
    fill: "#0095d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424059",
    "data-name": "Path 424059",
    d: "M635.411,1913.993c0,.112-.2.216-.565.314a38.727,38.727,0,0,1-7.807.565,39.633,39.633,0,0,1-7.758-.551c-.4-.1-.62-.209-.62-.328,0-.481,3.75-.864,8.378-.864s8.371.383,8.371.864",
    transform: "translate(-537.967 -1663.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424060",
    "data-name": "Path 424060",
    d: "M623.149,1911.565a40.432,40.432,0,0,1-7.9-.568c-.311-.078-1.057-.262-1.057-.894,0-.433,0-1.448,8.961-1.448s8.956,1.015,8.956,1.448c0,.609-.7.8-1,.878a39.383,39.383,0,0,1-7.96.583m7.949-1.11h0Zm-14.131-.347a66.15,66.15,0,0,0,12.365,0,67.194,67.194,0,0,0-12.365,0",
    transform: "translate(-534.076 -1659.701)",
    fill: "#0095d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424061",
    "data-name": "Path 424061",
    d: "M606.9,1973.812c0,1.784.314,3.889-.209,5.618-.453,1.505-1.443,1.945-2.92,1.945H591.578c-2.635,0-5.276.021-7.918,0a4.282,4.282,0,0,1-2.593-.641,1.2,1.2,0,0,1-.1-.091c-.774-.676-.676-1.6-.662-2.551.014-1.854,0-3.708,0-5.569v-14.184a16.769,16.769,0,0,1,.362-5.123c.754-2.2,3.613-1.39,5.322-1.263a15.741,15.741,0,0,1,1.56.243,14.348,14.348,0,0,0,1.878.134c1.581.068,3.164.067,4.749.067,1.193,0,2.4.005,3.589-.045.836-.035,1.663-.173,2.5-.173,1.024,0,2.044-.173,3.054-.219,1.071-.048,2.164-.258,3.022.547a2.284,2.284,0,0,1,.6,1.013,9.661,9.661,0,0,1-.03,2.972c-.042.9-.007,1.805-.007,2.712Z",
    transform: "translate(-504.589 -1697.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424062",
    "data-name": "Path 424062",
    d: "M582.407,1978.11q-1.322,0-2.646-.009a4.8,4.8,0,0,1-2.946-.766l-.153-.13a3.158,3.158,0,0,1-.845-2.729l0-.251c.01-1.231.007-2.465,0-3.7l0-16.044c0-.294-.006-.6-.011-.919a13.31,13.31,0,0,1,.406-4.393c.785-2.291,3.341-1.968,5.029-1.756.317.041.617.08.888.1a11.391,11.391,0,0,1,1.247.18l.369.068a9.992,9.992,0,0,0,1.4.112l.4.014c1.52.066,3.066.064,4.576.066h.424c1.076-.007,2.2,0,3.288-.046.351-.014.7-.048,1.047-.08,1.061-.1,2.133-.1,3.192-.205.44-.043.878-.087,1.314-.107l.433-.025a3.686,3.686,0,0,1,3.014.73,2.863,2.863,0,0,1,.764,1.288,6.31,6.31,0,0,1,.057,2.351c-.027.269-.055.536-.067.8-.027.607-.021,1.215-.013,1.826l.007.859v14.61c0,.467.022.96.045,1.459a13.08,13.08,0,0,1-.279,4.327,3.208,3.208,0,0,1-3.479,2.36l-14.824,0q-1.322,0-2.644,0m-3.038-29.68c-1.026,0-1.752.253-2.048,1.117a12.544,12.544,0,0,0-.342,3.994c.006.324.011.638.011.939l0,16.042c0,1.24.007,2.478,0,3.716l-.006.262c-.019.9-.008,1.43.469,1.844a3.763,3.763,0,0,0,2.319.588c1.758.014,3.516.009,5.276,0l14.827,0c1.386,0,2.027-.415,2.362-1.53a12.232,12.232,0,0,0,.23-3.937c-.023-.518-.046-1.026-.046-1.512l-.007-15.455c-.008-.634-.015-1.265.015-1.895.013-.283.042-.572.072-.864a5.406,5.406,0,0,0-.023-1.927,1.692,1.692,0,0,0-.434-.741,2.656,2.656,0,0,0-2.141-.417l-.457.027c-.416.018-.833.059-1.253.1-1.06.1-2.133.1-3.2.205-.368.037-.738.071-1.108.087-1.106.046-2.209.046-3.338.046h-.423c-1.514.007-3.081,0-4.626-.066l-.387-.016a11,11,0,0,1-1.566-.128l-.381-.068a10.771,10.771,0,0,0-1.121-.167c-.291-.021-.611-.061-.95-.1a14.546,14.546,0,0,0-1.731-.141",
    transform: "translate(-500.695 -1693.273)",
    fill: "#0095d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424063",
    "data-name": "Path 424063",
    d: "M607.053,2015.888v11.4c-7.59.279-19.474.481-26.6-.474v-10.5c5.492.028,17.509.042,26.6-.418",
    transform: "translate(-504.743 -1752.946)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199389",
    "data-name": "Rectangle 199389",
    width: 1.952,
    height: 6.97,
    transform: "translate(88.126 265.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199390",
    "data-name": "Rectangle 199390",
    width: 6.97,
    height: 1.952,
    transform: "translate(85.617 267.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199391",
    "data-name": "Rectangle 199391",
    width: 19.844,
    height: 5.769,
    transform: "translate(115.497 242.103)",
    fill: "#0095d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424064",
    "data-name": "Path 424064",
    d: "M906.733,1851.484c0,.129-.235.25-.655.364a44.924,44.924,0,0,1-9.053.655,45.928,45.928,0,0,1-9-.638c-.461-.113-.719-.243-.719-.38,0-.558,4.348-1,9.715-1s9.707.444,9.707,1",
    transform: "translate(-771.574 -1609.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424065",
    "data-name": "Path 424065",
    d: "M893.134,1849.2a46.538,46.538,0,0,1-9.144-.657c-.34-.084-1.155-.287-1.155-.946,0-.433,0-1.585,10.3-1.585s10.292,1.151,10.292,1.585c0,.634-.76.839-1.085.928a45.337,45.337,0,0,1-9.206.675m-7.894-1.6a58.714,58.714,0,0,0,7.894.431,59.455,59.455,0,0,0,7.887-.431,74.028,74.028,0,0,0-15.782,0m17.163.326h0Z",
    transform: "translate(-767.684 -1605.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424066",
    "data-name": "Path 424066",
    d: "M873.667,1920.852c0,2.069.364,4.51-.242,6.515-.525,1.746-1.673,2.255-3.387,2.255H855.9c-3.055,0-6.119.024-9.182,0a4.965,4.965,0,0,1-3.007-.744,1.382,1.382,0,0,1-.121-.105c-.9-.784-.784-1.851-.768-2.958.016-2.15,0-4.3,0-6.458v-16.448c0-1.867-.186-4.171.42-5.941.874-2.553,4.19-1.612,6.171-1.465.616.046,1.2.175,1.809.281a16.609,16.609,0,0,0,2.178.156c1.833.079,3.67.077,5.507.077,1.384,0,2.782.006,4.162-.052.97-.041,1.928-.2,2.9-.2,1.187,0,2.37-.2,3.542-.254,1.242-.056,2.51-.3,3.5.634a2.649,2.649,0,0,1,.695,1.175,11.207,11.207,0,0,1-.034,3.447c-.049,1.043-.008,2.094-.008,3.144Z",
    transform: "translate(-732.867 -1648.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424067",
    "data-name": "Path 424067",
    d: "M845.89,1926.378q-1.532,0-3.067-.011a5.435,5.435,0,0,1-3.36-.867,1.847,1.847,0,0,1-.181-.16,3.586,3.586,0,0,1-.939-3.085l.006-.29c.011-1.427.008-2.856,0-4.291l0-18.606c0-.342-.007-.7-.013-1.065a15.347,15.347,0,0,1,.465-5.064c.885-2.583,3.8-2.211,5.726-1.974.371.048.723.091,1.04.116a13.372,13.372,0,0,1,1.451.212l.416.078a12.264,12.264,0,0,0,1.637.13l.464.016c1.77.077,3.567.066,5.333.077h.539c1.242,0,2.5,0,3.747-.052.4-.016.806-.055,1.207-.094,1.225-.116,2.479-.114,3.712-.237.508-.05,1.016-.1,1.521-.123l.5-.03a4.187,4.187,0,0,1,3.432.821,3.219,3.219,0,0,1,.858,1.448,7.277,7.277,0,0,1,.064,2.7c-.032.312-.064.622-.079.928-.032.7-.023,1.413-.015,2.125l.008.992v16.942c0,.545.026,1.115.052,1.7a15.1,15.1,0,0,1-.32,4.986c-.711,2.367-2.483,2.67-3.945,2.67l-17.191,0q-1.532.007-3.065.007m-3.491-34.413c-1.229,0-2.135.3-2.5,1.354a14.54,14.54,0,0,0-.4,4.665c.006.372.013.736.013,1.085l0,18.6c0,1.436.008,2.873,0,4.307l-.006.3c-.023,1.04-.008,1.7.575,2.211a4.381,4.381,0,0,0,2.747.7c2.042.016,4.083.011,6.12,0l17.194,0c1.657,0,2.425-.5,2.828-1.84a14.294,14.294,0,0,0,.271-4.6c-.027-.6-.054-1.188-.054-1.749l-.008-17.92c-.008-.734-.017-1.466.017-2.193.015-.326.048-.659.082-.994a6.31,6.31,0,0,0-.029-2.273,2.058,2.058,0,0,0-.53-.9,3.138,3.138,0,0,0-2.557-.508l-.522.032c-.484.021-.971.068-1.46.116-1.2.119-2.469.123-3.714.24-.422.039-.844.08-1.268.1-1.258.055-2.523.057-3.8.052h-.538c-1.76,0-3.589,0-5.383-.078l-.454-.018a12.609,12.609,0,0,1-1.8-.146l-.43-.077a12.052,12.052,0,0,0-1.323-.2c-.334-.025-.707-.071-1.1-.121a16.756,16.756,0,0,0-1.982-.16",
    transform: "translate(-728.975 -1644.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424068",
    "data-name": "Path 424068",
    d: "M873.846,1969.644v13.215c-8.8.323-22.583.557-30.843-.55v-12.18c6.369.032,20.3.048,30.843-.485",
    transform: "translate(-733.046 -1712.734)",
    fill: "#0095d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199392",
    "data-name": "Rectangle 199392",
    width: 2.264,
    height: 8.083,
    transform: "translate(124.353 259.611)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199393",
    "data-name": "Rectangle 199393",
    width: 8.083,
    height: 2.264,
    transform: "translate(121.443 262.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199394",
    "data-name": "Rectangle 199394",
    width: 19.844,
    height: 5.769,
    transform: "translate(155.507 246.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424069",
    "data-name": "Path 424069",
    d: "M1213.478,1886.629c0,.129-.234.251-.655.364a44.92,44.92,0,0,1-9.052.655,45.9,45.9,0,0,1-9-.639c-.461-.113-.719-.242-.719-.38,0-.558,4.349-1,9.715-1s9.707.445,9.707,1",
    transform: "translate(-1038.309 -1639.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424070",
    "data-name": "Path 424070",
    d: "M1199.881,1884.347a46.678,46.678,0,0,1-9.145-.657c-.34-.084-1.155-.287-1.155-.946,0-.433,0-1.584,10.3-1.584s10.29,1.151,10.29,1.584c0,.634-.76.839-1.085.928a45.321,45.321,0,0,1-9.205.675m-7.887-1.6a72.186,72.186,0,0,0,15.773,0,74.143,74.143,0,0,0-15.773,0m17.155.328h0Z",
    transform: "translate(-1034.418 -1635.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424071",
    "data-name": "Path 424071",
    d: "M1180.413,1956c0,2.069.364,4.51-.242,6.515-.526,1.746-1.673,2.255-3.387,2.255h-14.137c-3.055,0-6.119.024-9.182,0a4.964,4.964,0,0,1-3.007-.744,1.412,1.412,0,0,1-.121-.105c-.9-.784-.784-1.851-.768-2.958.016-2.15,0-4.3,0-6.458v-16.448c0-1.867-.186-4.171.42-5.941.875-2.553,4.19-1.612,6.171-1.465a18.273,18.273,0,0,1,1.809.281,16.633,16.633,0,0,0,2.178.156c1.833.079,3.67.077,5.507.077,1.384,0,2.782.006,4.162-.052.97-.041,1.928-.2,2.9-.2,1.188,0,2.37-.2,3.542-.254,1.242-.056,2.51-.3,3.5.634a2.65,2.65,0,0,1,.694,1.176,11.206,11.206,0,0,1-.034,3.447c-.048,1.043-.008,2.093-.008,3.144Z",
    transform: "translate(-999.602 -1678.572)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424072",
    "data-name": "Path 424072",
    d: "M1152.635,1961.515q-1.534,0-3.067-.011a5.466,5.466,0,0,1-3.359-.866,2.142,2.142,0,0,1-.171-.146,3.6,3.6,0,0,1-.951-3.1l.006-.29c.011-1.427.008-2.857,0-4.291l0-18.606c0-.342-.007-.7-.012-1.067a15.349,15.349,0,0,1,.465-5.064c.885-2.585,3.8-2.212,5.733-1.972.369.048.719.091,1.034.116a12.774,12.774,0,0,1,1.422.208l.442.08a12.063,12.063,0,0,0,1.646.132l.457.016c1.77.075,3.591.071,5.329.075h.555c1.252.009,2.5,0,3.736-.05.4-.016.8-.055,1.206-.094,1.222-.119,2.478-.119,3.707-.239.511-.05,1.019-.1,1.525-.123l.507-.03a4.194,4.194,0,0,1,3.422.821,3.21,3.21,0,0,1,.858,1.45,7.269,7.269,0,0,1,.064,2.7c-.032.313-.064.625-.079.93-.032.7-.023,1.414-.015,2.125l.008.992v16.94c0,.545.026,1.117.052,1.7a15.107,15.107,0,0,1-.32,4.986c-.711,2.366-2.483,2.67-3.945,2.67l-17.19,0q-1.532.007-3.065.007m-3.492-34.415c-1.229,0-2.134.3-2.494,1.354a14.545,14.545,0,0,0-.4,4.665c.006.374.013.739.013,1.088l0,18.6c0,1.436.008,2.873,0,4.307l-.006.3c-.023,1.04-.008,1.7.575,2.212a4.422,4.422,0,0,0,2.75.7c2.038.016,4.08.011,6.118,0l17.194,0c1.657,0,2.425-.5,2.828-1.84a14.3,14.3,0,0,0,.271-4.6c-.027-.6-.054-1.188-.054-1.751l-.008-17.918c-.008-.734-.017-1.466.017-2.193.015-.326.048-.659.082-.994a6.312,6.312,0,0,0-.028-2.273,2.058,2.058,0,0,0-.53-.9,3.152,3.152,0,0,0-2.548-.509l-.531.032c-.486.021-.974.071-1.463.119-1.2.116-2.467.125-3.712.24-.422.039-.844.08-1.268.1-1.257.05-2.525.05-3.786.05h-.554c-1.777.018-3.584,0-5.379-.075l-.447-.018a12.443,12.443,0,0,1-1.807-.148l-.453-.082a12.279,12.279,0,0,0-1.3-.192c-.333-.025-.7-.071-1.093-.121a16.424,16.424,0,0,0-1.989-.162",
    transform: "translate(-995.71 -1674.725)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424073",
    "data-name": "Path 424073",
    d: "M1180.592,2004.79v13.215c-8.8.323-22.583.557-30.843-.55v-12.181c6.369.032,20.3.049,30.843-.485",
    transform: "translate(-999.782 -1743.296)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199395",
    "data-name": "Rectangle 199395",
    width: 2.264,
    height: 8.083,
    transform: "translate(164.363 264.195)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199396",
    "data-name": "Rectangle 199396",
    width: 8.083,
    height: 2.264,
    transform: "translate(161.454 267.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424074",
    "data-name": "Path 424074",
    d: "M23.622,1402.286c3.322.437,5.826,2.168,5.824,3.9,0,.935-.721,1.726-1.889,2.226a3.084,3.084,0,0,1,1.885,2.463,2.4,2.4,0,0,0,0,4.7,3.068,3.068,0,0,1-1.889,2.454c1.167.508,1.886,1.3,1.885,2.235,0,1.728-2.508,3.454-5.83,3.886-3.6.469-6.772-.746-6.771-2.755,0-1.087.955-2.127,2.432-2.873-1.475-.563-2.428-1.49-2.427-2.577s.962-2.077,2.438-2.727c-1.475-.652-2.435-1.636-2.434-2.73s.955-2.012,2.431-2.58c-1.475-.741-2.428-1.783-2.427-2.87,0-2.008,3.173-3.218,6.775-2.744",
    transform: "translate(-14.638 -1219.289)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424075",
    "data-name": "Path 424075",
    d: "M18.169,1420.933a7.467,7.467,0,0,1-4.835-1.434,2.644,2.644,0,0,1-.977-2.005,3.614,3.614,0,0,1,1.784-2.817,3.136,3.136,0,0,1-1.779-2.634,2.978,2.978,0,0,0,0-5.457,3.152,3.152,0,0,1,1.784-2.634,3.591,3.591,0,0,1-1.779-2.817,2.642,2.642,0,0,1,.98-2c1.325-1.163,3.8-1.663,6.454-1.318,3.61.477,6.332,2.4,6.331,4.474a2.781,2.781,0,0,1-1.348,2.274,3.127,3.127,0,0,1,1.344,2.417,2.71,2.71,0,0,0,0,4.694,3.158,3.158,0,0,1-1.351,2.409,2.8,2.8,0,0,1,1.346,2.281c0,2.075-2.726,3.994-6.338,4.464a12.731,12.731,0,0,1-1.619.106m0-22.06a6.372,6.372,0,0,0-4.05,1.136,1.493,1.493,0,0,0-.583,1.127c0,.808.787,1.686,2.105,2.348a.585.585,0,0,1-.052,1.067c-1.288.495-2.056,1.256-2.058,2.036,0,.8.779,1.618,2.086,2.2a.584.584,0,0,1,0,1.068c-1.307.576-2.088,1.4-2.09,2.193,0,.781.766,1.54,2.051,2.03a.584.584,0,0,1,.056,1.066c-1.321.668-2.11,1.548-2.111,2.354a1.494,1.494,0,0,0,.58,1.128c1.064.935,3.229,1.346,5.532,1.046,3.285-.426,5.32-2.05,5.321-3.307,0-.656-.559-1.276-1.534-1.7a.583.583,0,0,1-.048-1.046c1.008-.553,1.586-1.261,1.587-1.943s-.571-1.334-1.565-1.825a.583.583,0,0,1,0-1.046c1-.49,1.567-1.155,1.569-1.824s-.577-1.392-1.586-1.952a.585.585,0,0,1,.055-1.048c.975-.417,1.534-1.033,1.534-1.69,0-1.258-2.031-2.884-5.317-3.316a11.243,11.243,0,0,0-1.482-.1",
    transform: "translate(-10.745 -1215.397)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_829",
    "data-name": "Line 829",
    x2: 8.283,
    y2: 0.507,
    transform: "translate(4.636 188.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424076",
    "data-name": "Path 424076",
    d: "M39.935,1443.2H39.9l-8.283-.507a.583.583,0,0,1-.547-.618.571.571,0,0,1,.618-.547l8.283.507a.584.584,0,0,1-.035,1.166",
    transform: "translate(-27.016 -1253.497)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_830",
    "data-name": "Line 830",
    x2: 8.271,
    y2: 0.007,
    transform: "translate(4.639 193.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424077",
    "data-name": "Path 424077",
    d: "M39.941,1483.421h0l-8.272-.007a.584.584,0,0,1,0-1.167l8.272.007a.584.584,0,1,1,0,1.167",
    transform: "translate(-27.031 -1288.91)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424078",
    "data-name": "Path 424078",
    d: "M36.466,1524.539c0,.084,8.28-.5,8.28-.5",
    transform: "translate(-31.71 -1325.251)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424079",
    "data-name": "Path 424079",
    d: "M34.142,1521.21c-.562,0-.625-.058-.723-.149l.4-.427h0l.068-.576c.377-.008,5.231-.3,8.17-.507a.591.591,0,0,1,.623.542.584.584,0,0,1-.541.624c-5.108.36-7.135.5-8,.5",
    transform: "translate(-29.06 -1321.344)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_831",
    "data-name": "Line 831",
    y1: 28.114,
    x2: 2.626,
    transform: "translate(97.217 169.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424080",
    "data-name": "Path 424080",
    d: "M741.444,1326.306l-.056,0a.585.585,0,0,1-.527-.636l2.626-28.114a.584.584,0,0,1,1.163.109l-2.627,28.114a.584.584,0,0,1-.58.529",
    transform: "translate(-644.225 -1127.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424081",
    "data-name": "Path 424081",
    d: "M190.468,166.723c0,15.649,14.011,28.336,31.295,28.336s31.295-12.686,31.295-28.336-14.011-28.336-31.295-28.336-31.295,12.687-31.295,28.336",
    transform: "translate(-165.624 -120.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424082",
    "data-name": "Path 424082",
    d: "M235.893,204.781c0,12.687,11.359,22.971,25.37,22.971s25.37-10.285,25.37-22.971-11.359-22.971-25.37-22.971-25.37,10.285-25.37,22.971",
    transform: "translate(-205.124 -158.096)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424083",
    "data-name": "Path 424083",
    d: "M414.659,206.85a2.176,2.176,0,1,0,2.17-2.013,2.1,2.1,0,0,0-2.17,2.013",
    transform: "translate(-360.573 -178.119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424084",
    "data-name": "Path 424084",
    d: "M414.659,482.152a2.176,2.176,0,1,0,2.17-2.013,2.1,2.1,0,0,0-2.17,2.013",
    transform: "translate(-360.573 -417.512)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424085",
    "data-name": "Path 424085",
    d: "M563.628,341.443a2.153,2.153,0,1,0,2.033,2.149,2.093,2.093,0,0,0-2.033-2.149",
    transform: "translate(-488.343 -296.907)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424086",
    "data-name": "Path 424086",
    d: "M262.287,341.443a2.153,2.153,0,1,0,2.033,2.149,2.093,2.093,0,0,0-2.033-2.149",
    transform: "translate(-226.308 -296.907)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424087",
    "data-name": "Path 424087",
    d: "M444.531,274.993a.583.583,0,0,1-.444-.2l-11.4-13.315a.588.588,0,0,1-.14-.394c.128-4.9.249-12.968.032-13.75a.6.6,0,0,1,.376-.728.57.57,0,0,1,.722.331c.343.907.128,10.624.043,13.954l11.251,13.144a.584.584,0,0,1-.443.963",
    transform: "translate(-376.13 -214.409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424088",
    "data-name": "Path 424088",
    d: "M414.154,335.444a2.935,2.935,0,1,0,3.079,2.932,3.008,3.008,0,0,0-3.079-2.932",
    transform: "translate(-357.457 -291.69)",
    fill: "#08f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424089",
    "data-name": "Path 424089",
    d: "M272.657,781.274c1.346.636,3.57.612,5.18.612H299.2c1.346,0,2.692,0,4.067.025,3.249,3.693,7.2,8.194,7.375,8.39.205.22.146-4.819.059-8.316,1.229.024,2.429.024,3.629.024a3.726,3.726,0,0,0,2.107-.563c1.785-1.247.878-4.3.878-5.6V761.657c0-1.2.673-3.694-.614-4.623-1.4-.979-5.326-.563-7.345-.563H283.485c-2.9,0-5.853-.122-8.691-.147-4.419,0-2.926,7.314-2.926,8.977v10.714a11.144,11.144,0,0,1-.234,2.96,1.758,1.758,0,0,0,1.025,2.3",
    transform: "translate(-236.108 -657.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424090",
    "data-name": "Path 424090",
    d: "M306.791,787a.615.615,0,0,1-.448-.191c-.1-.106-1.175-1.335-2.645-3.006l-4.57-5.2c-1.284-.021-2.541-.021-3.8-.021H273.789c-1.607-.024-3.837,0-5.253-.667l-.007,0a2.343,2.343,0,0,1-1.328-2.986,9.486,9.486,0,0,0,.211-2.52V761.409c0-.249-.037-.629-.079-1.1-.195-2.119-.52-5.666,1.094-7.436a3.228,3.228,0,0,1,2.494-1.029c1.253.011,2.522.041,3.8.071,1.629.038,3.27.076,4.893.076h25.869c.418,0,.92-.018,1.464-.038,2.209-.078,4.947-.178,6.215.706,1.272.918,1.077,2.793.936,4.162-.037.356-.072.679-.072.939v14.187a9.76,9.76,0,0,0,.089,1.006c.185,1.554.463,3.9-1.216,5.075a4.3,4.3,0,0,1-2.425.668c-1.022-.008-2.026,0-3.047-.015.193,8.02.022,8.089-.419,8.269a.592.592,0,0,1-.216.041m-32.825-9.586h21.363c1.35,0,2.7,0,4.078.025a.585.585,0,0,1,.427.2l4.742,5.394c.685.781,1.286,1.464,1.74,1.98.026-1.447,0-4.007-.071-6.9a.584.584,0,0,1,.17-.426.545.545,0,0,1,.425-.172c1.226.025,2.421.025,3.618.025a3.212,3.212,0,0,0,1.762-.451c1.116-.78.9-2.633.735-3.988a10.781,10.781,0,0,1-.1-1.142V757.764c0-.293.036-.659.077-1.06.113-1.085.267-2.572-.45-3.089-.94-.654-3.681-.554-5.5-.491-.56.021-1.075.039-1.506.039H279.614c-1.632,0-3.282-.039-4.92-.076-1.271-.03-2.535-.059-3.778-.071a2.075,2.075,0,0,0-1.625.649c-1.268,1.39-.961,4.742-.8,6.543.048.511.084.929.084,1.2V772.4a10.513,10.513,0,0,1-.254,2.837,1.189,1.189,0,0,0,.714,1.622,12.752,12.752,0,0,0,4.75.553Z",
    transform: "translate(-232.237 -653.781)",
    fill: "#08f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424091",
    "data-name": "Path 424091",
    d: "M340.918,800.838h-9.687a.584.584,0,0,1-.556-.407l-1.118-3.513-2.686,3.681a.587.587,0,0,1-.472.239h-6.322a.583.583,0,0,1-.555-.4l-2.471-7.659-3.486,7.721a.585.585,0,0,1-.532.343h-8.5a.584.584,0,1,1,0-1.167h8.125l3.955-8.756a.545.545,0,0,1,.565-.342.583.583,0,0,1,.522.4l2.805,8.695h5.6l3.19-4.371a.576.576,0,0,1,.565-.231.583.583,0,0,1,.463.4l1.337,4.2h9.261a.584.584,0,1,1,0,1.167",
    transform: "translate(-264.301 -687.45)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellnessFeatureMedicines);
export default __webpack_public_path__ + "static/media/wellness-feature-medicines.d56e0dc3bca8da10a2a6564d0265831c.svg";
export { ForwardRef as ReactComponent };